import { useEffect, useState } from 'react';
import { useTranslation } from '../../../../../i18n/hooks/useTranslation';

const checkerClass = 'bg-[length:16px_16px] bg-[position:0_0,8px_8px] bg-[image:linear-gradient(45deg,#ECE8E4_25%,transparent_25%,transparent_75%,#ECE8E4_75%,#ECE8E4),linear-gradient(45deg,#ECE8E4_25%,transparent_25%,transparent_75%,#ECE8E4_75%,#ECE8E4)] dark:bg-[image:linear-gradient(45deg,#3f3f46_25%,transparent_25%,transparent_75%,#3f3f46_75%,#3f3f46),linear-gradient(45deg,#3f3f46_25%,transparent_25%,transparent_75%,#3f3f46_75%,#3f3f46)]';

export default function LogoColorChangerPreview({
    file,
    previewUrl,
    beforeLabelKey = 'logoColorChangerImage.previewBefore',
    afterLabelKey = 'logoColorChangerImage.previewAfter',
}) {
    const { t } = useTranslation();
    const [originalUrl, setOriginalUrl] = useState(null);

    useEffect(() => {
        if (!file) {
            setOriginalUrl(null);
            return undefined;
        }
        const url = URL.createObjectURL(file);
        setOriginalUrl(url);
        return () => URL.revokeObjectURL(url);
    }, [file]);

    if (!file) return null;

    return (
        <div className="grid h-full min-h-0 grid-cols-1 gap-3 md:grid-cols-2">
            <div className="flex min-h-0 flex-col gap-1.5">
                <span className="text-center text-[11.5px] font-semibold text-[#6B635C] dark:text-zinc-400">
                    {t(beforeLabelKey)}
                </span>
                <div className={`flex min-h-0 flex-1 items-center justify-center overflow-hidden rounded-xl border border-[#ECE8E4] p-2 dark:border-zinc-700 ${checkerClass}`}>
                    {originalUrl ? (
                        <img
                            src={originalUrl}
                            alt={file.name}
                            className="max-h-full max-w-full object-contain"
                            draggable={false}
                        />
                    ) : null}
                </div>
            </div>
            <div className="flex min-h-0 flex-col gap-1.5">
                <span className="text-center text-[11.5px] font-semibold text-[#1E9E5E]">
                    {t(afterLabelKey)}
                </span>
                <div className={`flex min-h-0 flex-1 items-center justify-center overflow-hidden rounded-xl border border-[#ECE8E4] p-2 dark:border-zinc-700 ${checkerClass}`}>
                    {previewUrl ? (
                        <img
                            src={previewUrl}
                            alt=""
                            className="max-h-full max-w-full object-contain"
                            draggable={false}
                        />
                    ) : null}
                </div>
            </div>
        </div>
    );
}
